import { useParams } from "react-router-dom";
import { TitlePage } from "../../components/ui/TitlePage";
import { useEffect, useState } from "react";
import { api, urls } from "../../services/api";
import { IMenu, IMenuItem } from "../../types/menu";
import { useApp } from "../../context/App";
import { ServicesAccordion } from "../../components/sections/ServicesAccordion";
import { Banner } from "../../components/sections/Banner";
import { ISearch } from "../../types/search";
import { SubTitlePage } from "../../components/ui/SubTitlePage";

export function SearchScreen() {

	const { configDomainURL, mobile } = useApp()
	const domain = configDomainURL
	let { searchText } = useParams();

	const [search, setSearch] = useState<ISearch>({
		artigos: [],
		noticias: [],
		servicos: [],
		menus: [],
		acesso_rapido: [],
		videos: [],
	})

	const [listMenu, setMenuList] = useState<IMenu[]>([])
	const [finded, setFinded] = useState<boolean>(false)
	const [loading, setLoading] = useState<string>('Carregando...')
	const [buscaValor, setBuscaValor] = useState<string>('')
	const [counterString, setCounterString] = useState<string>('1 Resultado')
	const [countNoticias, setCountNoticias] = useState<number>(0)
	const [countServicos, setCountServicos] = useState<number>(0)
	const [countArtigos, setCountArtigos] = useState<number>(0)
	const [countMenus, setCountMenus] = useState<number>(0)
	const [countAcessoRapido, setCountAcessoRapido] = useState<number>(0)
	const [countVideos, setCountVideos] = useState<number>(0)
	const [activeFilter, setActiveFilter] = useState<string>('all')

	setTimeout(function () { setLoading('Nenhuma informação encontrada.') }, 3000);

	const getSearchByText = async (inputSearch: string) => {

		try {

			inputSearch = decodeURIComponent(inputSearch)

			const response = await api.get(urls.Pesquisa + inputSearch)



			setBuscaValor(inputSearch)

			if (
				(
					response.data.artigos
					&& response.data.artigos.length > 0
				)
				|| (
					response.data.servicos
					&& response.data.servicos.length > 0
				)
				|| (
					response.data.noticias
					&& response.data.noticias.length > 0
				)
				|| (
					response.data.menus
					&& response.data.menus.length > 0
				)
				|| (
					response.data.acesso_rapido
					&& response.data.acesso_rapido.length > 0
				)
				|| (
					response.data.videos
					&& response.data.videos.length > 0
				)
			) {

				setSearch({ ...response.data })
				setFinded(true)

			}

			if (response.data.noticias) {

				setCountNoticias(response.data.noticias.length)

			}

			if (response.data.servicos) {

				setCountServicos(response.data.servicos.length)

			}

			if (response.data.artigos) {

				setCountArtigos(response.data.artigos.length)

			}

			if (response.data.menus) {

				setCountMenus(response.data.menus.length)

			}

			if (response.data.acesso_rapido) {

				setCountAcessoRapido(response.data.acesso_rapido.length)

			}

			if (response.data.videos) {

				setCountVideos(response.data.videos.length)

			}

		}
		catch (error) {
			// error silent
		}

	}

	useEffect(() => {
		searchText && getSearchByText(searchText)
	}, [searchText])

	useEffect(() => {
		(async () => {
			const response = await api.get(urls.menus)
			const menu: IMenuItem[] = response.data
			if (menu && menu.length > 0 && menu[0].secoes && menu[0].secoes.length > 0) {
				const menuFiltered = menu[0].secoes[0].menus as IMenu[]
				setMenuList([...menuFiltered])
			} else if (menu && menu.length > 0 && menu[0].menus) {
				setMenuList([...menu[0].menus])
			}
		})()
	}, [])

	useEffect(() => {
		setCounterString((countNoticias + countServicos + countArtigos) + ' Resultados')
	}, [countNoticias, countServicos, countArtigos])

	if (listMenu.length < 1) {
		return <></>
	}

	const FilterChip = ({ label, count, id }: { label: string, count: number, id: string }) => {
		if (count === 0 && id !== 'all') return null;
		const isActive = activeFilter === id;
		return (
			<button
				onClick={() => setActiveFilter(id)}
				className={`flex items-center justify-between px-4 py-2.5 rounded-xl text-xs font-bold uppercase tracking-wider transition-all duration-300 border border-none cursor-pointer w-full text-left
                ${isActive
						? 'bg-primary text-white shadow-md'
						: 'bg-surface-alt dark:bg-surface-dark-alt text-on-surface-subtle dark:text-on-surface-dark-muted hover:bg-border-default dark:hover:bg-border-default-dark'}`}
			>
				<span>{label}</span>
				<span className={`px-2 py-0.5 rounded-full text-[10px] ${isActive ? 'bg-white/20' : 'bg-primary/5 dark:bg-white/5'}`}>
					{count}
				</span>
			</button>
		);
	};



	if (mobile) {
		return (
			<div className="flex flex-col w-full min-h-screen bg-white dark:bg-surface-dark transition-colors items-center justify-start pb-20">
				<TitlePage title={'Busca Geral'} />

				<form
					className="w-11/12 h-14 flex flex-row rounded-xl border border-border-default dark:border-border-default-dark bg-surface-alt dark:bg-surface-dark-alt mt-8 overflow-hidden focus-within:ring-2 focus-within:ring-primary/40 transition-all shadow-sm"
					onSubmit={(e) => {
						e.preventDefault();
						if (buscaValor.trim()) {
							window.location.href = `/busca/${encodeURIComponent(buscaValor.trim())}`;
						}
					}}
				>
					<input
						className="w-full bg-transparent border-none text-on-surface dark:text-on-surface-dark text-base font-normal font-roboto pl-4 outline-none placeholder:text-on-surface-subtle"
						placeholder="Digite o que deseja encontrar..."
						defaultValue={searchText || ''}
						onChange={(e) => setBuscaValor(e.target.value)}
						aria-label="Campo de busca"
					/>
					<button
						className="h-full flex items-center justify-center bg-primary dark:bg-primary-light text-white border-none w-16 cursor-pointer transition-colors hover:bg-primary-dark"
						type="submit"
						aria-label="Buscar"
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
					</button>
				</form>

				<div className="flex flex-col w-11/12 mt-6 mb-8">
					<div className="flex flex-wrap gap-2 mb-8 sticky top-20 z-40 bg-white/80 dark:bg-surface-dark/80 backdrop-blur-md py-2 px-1 rounded-2xl">
						<button
							onClick={() => setActiveFilter('all')}
							className={`px-4 py-2 rounded-full text-[10px] font-bold uppercase tracking-widest transition-all border-none ${activeFilter === 'all' ? 'bg-primary text-white shadow-md shadow-primary/20' : 'bg-surface-alt dark:bg-surface-dark-alt text-on-surface-subtle dark:text-on-surface-dark-muted'}`}
						>Tudo</button>
						{countNoticias > 0 && <button onClick={() => setActiveFilter('noticias')} className={`px-4 py-2 rounded-full text-[10px] font-bold uppercase tracking-widest transition-all border-none ${activeFilter === 'noticias' ? 'bg-primary text-white shadow-md shadow-primary/20' : 'bg-surface-alt dark:bg-surface-dark-alt text-on-surface-subtle dark:text-on-surface-dark-muted'}`}>Notícias ({countNoticias})</button>}
						{countServicos > 0 && <button onClick={() => setActiveFilter('servicos')} className={`px-4 py-2 rounded-full text-[10px] font-bold uppercase tracking-widest transition-all border-none ${activeFilter === 'servicos' ? 'bg-primary text-white shadow-md shadow-primary/20' : 'bg-surface-alt dark:bg-surface-dark-alt text-on-surface-subtle dark:text-on-surface-dark-muted'}`}>Serviços ({countServicos})</button>}
						{countArtigos > 0 && <button onClick={() => setActiveFilter('artigos')} className={`px-4 py-2 rounded-full text-[10px] font-bold uppercase tracking-widest transition-all border-none ${activeFilter === 'artigos' ? 'bg-primary text-white shadow-md shadow-primary/20' : 'bg-surface-alt dark:bg-surface-dark-alt text-on-surface-subtle dark:text-on-surface-dark-muted'}`}>Artigos ({countArtigos})</button>}
					</div>

					{!finded ? (
						<div className="py-12 text-center text-on-surface-subtle dark:text-on-surface-dark-muted font-medium">{loading}</div>
					) : (
						<div className="flex flex-col gap-12">
							{(activeFilter === 'all' || activeFilter === 'noticias') && search.noticias && search.noticias.length > 0 && (
								<div className="flex flex-col gap-4">
									<SubTitlePage title="Notícias" />
									<div className="flex flex-col divide-y divide-border-default dark:divide-white/5">
										{search.noticias.map((item, idx) => (
											<a
												key={idx}
												className="py-4 text-primary dark:text-secondary-light font-medium no-underline hover:translate-x-1 transition-transform"
												href={`${domain}noticias/${item.cod_noticia}/${item.titulo.replaceAll('/', '-').replaceAll(' ', '-').toLowerCase()}`}
											>• {item.titulo}</a>
										))}
									</div>
								</div>
							)}

							{(activeFilter === 'all' || activeFilter === 'servicos') && search.servicos && search.servicos.length > 0 && (
								<div className="flex flex-col gap-4">
									<SubTitlePage title="Serviços" />
									<div className="flex flex-col divide-y divide-border-default dark:divide-white/5">
										{search.servicos.map((item, idx) => (
											<a
												key={idx}
												className="py-4 text-primary dark:text-secondary-light font-medium no-underline hover:translate-x-1 transition-transform"
												href={`https://api-portal.itajai.sc.gov.br/portaladm-pmitajai/servico/acesso/cod/${item.cod_servico}`}
											>• {item.titulo}</a>
										))}
									</div>
								</div>
							)}

							{(activeFilter === 'all' || activeFilter === 'artigos') && search.artigos && search.artigos.length > 0 && (
								<div className="flex flex-col gap-4">
									<SubTitlePage title="Artigos" />
									<div className="flex flex-col divide-y divide-border-default dark:divide-white/5">
										{search.artigos.map((item, idx) => (
											<a
												key={idx}
												className="py-4 text-primary dark:text-secondary-light font-medium no-underline hover:translate-x-1 transition-transform"
												href={`${domain}e/${item.cod_artigo}`}
											>• {item.titulo}</a>
										))}
									</div>
								</div>
							)}
						</div>
					)}
				</div>

				<ServicesAccordion />
				<Banner mobile={mobile} />
			</div>
		)
	}

	return (
		<div className="flex flex-col w-full min-h-screen bg-white dark:bg-surface-dark transition-colors items-center justify-start font-roboto">
			<TitlePage title={'Busca Geral'} />

			<div className="flex flex-row w-[85%] max-w-7xl mt-12 mb-24">
				{!finded ? (
					<div className="w-full py-20 flex flex-col items-center justify-center text-center font-semibold text-on-surface-subtle dark:text-on-surface-dark-muted">
						{!searchText ? (
							<div className="flex flex-col items-center w-full max-w-lg gap-4">
								<span className="text-lg">Faça uma busca utilizando a barra abaixo:</span>
								<form
									className="w-full h-14 flex flex-row rounded-xl border border-border-default dark:border-border-default-dark bg-surface-alt dark:bg-surface-dark-alt overflow-hidden focus-within:ring-2 focus-within:ring-primary/40 transition-all shadow-sm"
									onSubmit={(e) => {
										e.preventDefault();
										if (buscaValor.trim()) {
											window.location.href = `/busca/${encodeURIComponent(buscaValor.trim())}`;
										}
									}}
								>
									<input
										className="w-full bg-transparent border-none text-on-surface dark:text-on-surface-dark text-base font-normal font-roboto pl-4 outline-none placeholder:text-on-surface-subtle"
										placeholder="O que você busca?"
										onChange={(e) => setBuscaValor(e.target.value)}
									/>
									<button
										className="h-full flex items-center justify-center bg-primary text-white border-none w-16 cursor-pointer hover:bg-primary-dark transition-colors"
										type="submit"
									>
										<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
									</button>
								</form>
							</div>
						) : loading}
					</div>
				) : (
					<>
						<aside className="flex flex-col w-1/4 pr-12 gap-8 sticky top-24 h-fit">
							<div className="flex flex-col gap-2">
								<h2 className="text-primary dark:text-on-surface-dark text-xl font-black uppercase">Resultados</h2>
								<p className="text-on-surface-subtle dark:text-on-surface-dark-muted text-sm italic">Busca por: "{buscaValor}"</p>
								<span className="text-[10px] font-black uppercase bg-primary text-white w-fit px-2 py-1 rounded-md">{counterString}</span>
							</div>

							<div className="flex flex-col gap-2 pt-6 border-t border-border-default dark:border-white/10">
								<h4 className="text-[10px] font-black uppercase tracking-widest text-on-surface-subtle dark:text-on-surface-dark-muted mb-2">Categorias</h4>
								<FilterChip label="Tudo" count={countNoticias + countServicos + countArtigos + countMenus + countAcessoRapido + countVideos} id="all" />
								<FilterChip label="Notícias" count={countNoticias} id="noticias" />
								<FilterChip label="Serviços" count={countServicos} id="servicos" />
								<FilterChip label="Artigos" count={countArtigos} id="artigos" />
								<FilterChip label="Acesso Rápido" count={countAcessoRapido} id="acesso_rapido" />
								<FilterChip label="Menus" count={countMenus} id="menus" />
								<FilterChip label="Vídeos" count={countVideos} id="videos" />
							</div>
						</aside>

						<main className="flex flex-col w-3/4 gap-16 border-l border-border-default/50 dark:border-white/5 pl-12">
							{(activeFilter === 'all' || activeFilter === 'acesso_rapido') && search.acesso_rapido && search.acesso_rapido.length > 0 && (
								<section className="flex flex-col gap-6">
									<SubTitlePage title="Acesso Rápido" />
									<div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
										{search.acesso_rapido.map((item, idx) => (
											<a key={idx} href={`${item.url}`} className="py-2 text-sm text-on-surface-subtle dark:text-on-surface-dark-muted hover:text-primary dark:hover:text-secondary no-underline flex items-start gap-2 group">
												<span className="text-primary/20 dark:text-white/10 group-hover:text-secondary transition-colors">•</span>
												{item.titulo}
											</a>
										))}
									</div>
								</section>
							)}

							{(activeFilter === 'all' || activeFilter === 'servicos') && search.servicos && search.servicos.length > 0 && (
								<section className="flex flex-col gap-6">
									<SubTitlePage title="Serviços Públicos" />
									<div className="flex flex-col gap-3">
										{search.servicos.map((item, idx) => (
											<a key={idx} href={`https://api-portal.itajai.sc.gov.br/portaladm-pmitajai/servico/acesso/cod/${item.cod_servico}`} className="p-4 rounded-xl border border-border-default dark:border-white/5 hover:border-primary/30 dark:hover:border-secondary/30 bg-surface-alt/50 dark:bg-white/5 no-underline transition-all hover:shadow-sm">
												<h4 className="text-primary dark:text-secondary-light font-bold mb-1">{item.titulo}</h4>
												<p className="text-xs text-on-surface-subtle dark:text-on-surface-dark-muted truncate">Acessar serviço municipal</p>
											</a>
										))}
									</div>
								</section>
							)}

							{(activeFilter === 'all' || activeFilter === 'noticias') && search.noticias && search.noticias.length > 0 && (
								<section className="flex flex-col gap-6">
									<SubTitlePage title="Notícias Relacionadas" />
									<div className="flex flex-col divide-y divide-border-default dark:divide-white/5">
										{search.noticias.map((item, idx) => (
											<a key={idx} href={`${domain}noticias/${item.cod_noticia}/${item.titulo.replaceAll('/', '-').replaceAll(' ', '-').toLowerCase()}`} className="py-5 no-underline group">
												<h4 className="text-heading dark:text-on-surface-dark group-hover:text-primary dark:group-hover:text-secondary transition-colors font-medium mb-1">{item.titulo}</h4>
												<span className="text-[10px] uppercase tracking-widest text-on-surface-subtle/50 dark:text-on-surface-dark-muted/50">Postado em Notícias</span>
											</a>
										))}
									</div>
								</section>
							)}

							{(activeFilter === 'all' || activeFilter === 'videos') && search.videos && search.videos.length > 0 && (
								<section className="flex flex-col gap-6">
									<SubTitlePage title="Vídeos" />
									<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
										{search.videos.map((item, idx) => (
											<a key={idx} href={`${item.caminho}`} target="_blank" rel="noreferrer" className="flex flex-col gap-3 no-underline group">
												<div className="aspect-video bg-black rounded-xl overflow-hidden shadow-sm group-hover:shadow-md transition-all">
													<img src={`https://img.youtube.com/vi/${item.caminho.split('v=')[1]}/hqdefault.jpg`} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" alt={item.titulo} />
												</div>
												<h4 className="text-sm font-bold text-on-surface dark:text-on-surface-dark group-hover:text-primary">{item.titulo}</h4>
											</a>
										))}
									</div>
								</section>
							)}
						</main>
					</>
				)}
			</div>
		</div>
	);
}